export default __webpack_public_path__ + "static/media/ad.afdb2ac5.png";